// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"7eeec492","545":"451026d4"}[chunkId] + ".chunk.js";
};